var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"constom-button-container",style:(_vm.areaStyle)},[_c('span',{staticClass:"constom-button",style:(_vm.buttonStyle),on:{"click":function($event){return _vm.jumpUrl(_vm.buttonContentData)}}},[_vm._v(" "+_vm._s(_vm.buttonContentData.buttonDes)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }